import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "15",
  height: "15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      "clip-path": "url(#a)",
      stroke: "#FF5E5E",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      _createElementVNode("path", { d: "M7.5 13.333a5.833 5.833 0 1 0 0-11.666 5.833 5.833 0 0 0 0 11.666ZM7.5 5.167V7.5M7.5 9.833h.005" })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          transform: "translate(.5 .5)",
          d: "M0 0h14v14H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render };